<div class="form-group">
    <label class="form-label" style="font-size: 15px;">Administrar Estatus</label>
    <a class="btn btn-success btn-round" style="float: left; color: white;" (click)="agregar_estatus()">Agregar Estatus</a>
    <table class="table">
        <thead>
            <tr>
                <td class="text-center">Estatus</td>
                <td class="text-center">Acciones</td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let estat of estatus; let i = index">
                <td>{{estat.estatus}}</td>
                <td class="text-center">
                    <a class="btn btn-outline-danger"  style="margin: 2px;" (click)="del_estatus(estat.id_estatus)"><i class="fa fa-trash-o"></i></a>
                    <a class="btn btn-outline-warning"  style="margin: 2px;" (click)="edit_estatus(estat.estatus, estat.id_estatus)"><i class="fa fa-edit"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
</div>